import React from "react";
import { motion } from "framer-motion";
import { Shield, FileCheck2, HardHat, Receipt } from "lucide-react";

const items = [
  {
    id: "nrta",
    icon: Shield,
    title: "National Road Traffic Act",
    desc:
      "All carriers we work with operate within the NRTA — roadworthy, permitted and licensed for the routes they run.",
  },
  {
    id: "ohsa",
    icon: HardHat,
    title: "Occupational Health & Safety",
    desc:
      "OHS Act compliance is non-negotiable on our network. Driver wellbeing, load safety and incident protocols are vetted.",
  },
  {
    id: "insurance",
    icon: FileCheck2,
    title: "Industry-Specific Insurance",
    desc:
      "Goods-in-transit and liability cover appropriate to each commodity, route and load value — verified before dispatch.",
  },
  {
    id: "sars",
    icon: Receipt,
    title: "South African Revenue Service",
    desc:
      "Tax-compliant operators with valid SARS standing — keeping your supply chain clean and your audits painless.",
  },
];

export default function Compliance() {
  return (
    <section id="compliance" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="text-xs md:text-sm uppercase tracking-[0.24em] font-bold text-[#0070C0]">
              Compliance
            </div>
            <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter text-[#002050] leading-[1.05]">
              Vetted carriers. Verified compliance.
            </h2>
            <p className="mt-5 text-lg text-[#1F2937]/75 leading-relaxed">
              Every carrier on the FreightXchange network is screened on four
              pillars of compliance — re-verified annually and audited per load
              where required.
            </p>
            <div className="mt-7 inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#002050] text-white text-sm font-bold">
              <Shield className="h-4 w-4 text-[#00AEEF]" />
              Zero-tolerance non-compliance policy
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <motion.div
                  key={it.id}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.45, delay: (i % 2) * 0.08 }}
                  className="bg-white rounded-2xl border border-[#E2E8F0] p-7 hover:border-[#0070C0]/40 hover:shadow-[0_20px_50px_-25px_rgba(0,32,80,0.25)] transition-all"
                >
                  <div className="flex items-center gap-3">
                    <div className="h-11 w-11 rounded-xl bg-[#0070C0]/10 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-[#0070C0]" strokeWidth={1.75} />
                    </div>
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#0070C0]">
                      Verified
                    </div>
                  </div>
                  <h3 className="font-display mt-5 text-xl font-bold text-[#002050] tracking-tight">
                    {it.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-[#1F2937]/75 leading-relaxed">
                    {it.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
